var map = {
	"./it-arrow-down-circle.svg": [
		34190,
		34190
	],
	"./it-arrow-down-triangle.svg": [
		9550,
		9550
	],
	"./it-arrow-down.svg": [
		53705,
		53705
	],
	"./it-arrow-left-circle.svg": [
		85624,
		85624
	],
	"./it-arrow-left-triangle.svg": [
		7927,
		7927
	],
	"./it-arrow-left.svg": [
		98231,
		98231
	],
	"./it-arrow-right-circle.svg": [
		85715,
		85715
	],
	"./it-arrow-right-triangle.svg": [
		26418,
		26418
	],
	"./it-arrow-right.svg": [
		80657,
		80657
	],
	"./it-arrow-up-circle.svg": [
		98416,
		98416
	],
	"./it-arrow-up-triangle.svg": [
		46235,
		46235
	],
	"./it-arrow-up.svg": [
		33424,
		73476
	],
	"./it-ban.svg": [
		29010,
		29010
	],
	"./it-behance.svg": [
		36258,
		36258
	],
	"./it-bookmark.svg": [
		11634,
		11634
	],
	"./it-box.svg": [
		70540,
		70540
	],
	"./it-burger.svg": [
		86544,
		86544
	],
	"./it-calendar.svg": [
		1233
	],
	"./it-camera.svg": [
		59005,
		59005
	],
	"./it-card.svg": [
		66223,
		66223
	],
	"./it-chart-line.svg": [
		61556,
		61556
	],
	"./it-check-circle.svg": [
		44413,
		44413
	],
	"./it-check.svg": [
		54549,
		54549
	],
	"./it-chevron-left.svg": [
		82631,
		82631
	],
	"./it-chevron-right.svg": [
		51026,
		51026
	],
	"./it-clip.svg": [
		23383,
		23383
	],
	"./it-clock.svg": [
		71437,
		71437
	],
	"./it-close-big.svg": [
		42025,
		42025
	],
	"./it-close-circle.svg": [
		84142,
		84142
	],
	"./it-close.svg": [
		36063,
		36063
	],
	"./it-code-circle.svg": [
		79238,
		79238
	],
	"./it-collapse.svg": [
		12604,
		12604
	],
	"./it-comment.svg": [
		39082,
		39082
	],
	"./it-copy.svg": [
		95651,
		95651
	],
	"./it-delete.svg": [
		1932,
		1932
	],
	"./it-designers-italia.svg": [
		78272,
		78272
	],
	"./it-download.svg": [
		18531,
		18531
	],
	"./it-error.svg": [
		30786,
		30786
	],
	"./it-exchange-circle.svg": [
		30444,
		30444
	],
	"./it-expand.svg": [
		90894,
		90894
	],
	"./it-external-link.svg": [
		38155,
		38155
	],
	"./it-facebook-square.svg": [
		20334,
		20334
	],
	"./it-facebook.svg": [
		62252,
		62252
	],
	"./it-figma-square.svg": [
		48660,
		48660
	],
	"./it-figma.svg": [
		53086,
		53086
	],
	"./it-file-audio.svg": [
		67464,
		67464
	],
	"./it-file-compressed.svg": [
		30327,
		30327
	],
	"./it-file-csv.svg": [
		27916,
		27916
	],
	"./it-file-json.svg": [
		89859,
		89859
	],
	"./it-file-odp.svg": [
		670,
		670
	],
	"./it-file-ods.svg": [
		97543,
		97543
	],
	"./it-file-odt.svg": [
		73850,
		73850
	],
	"./it-file-pdf-ext.svg": [
		51255,
		51255
	],
	"./it-file-pdf.svg": [
		38482,
		38482
	],
	"./it-file-ppt.svg": [
		11362,
		11362
	],
	"./it-file-sheet.svg": [
		12275,
		12275
	],
	"./it-file-slides.svg": [
		51299,
		51299
	],
	"./it-file-txt.svg": [
		34415,
		34415
	],
	"./it-file-video.svg": [
		35882,
		35882
	],
	"./it-file-xml.svg": [
		6618,
		6618
	],
	"./it-file.svg": [
		31513,
		31513
	],
	"./it-files.svg": [
		1784,
		1784
	],
	"./it-flag.svg": [
		67265,
		67265
	],
	"./it-flickr-square.svg": [
		8446,
		8446
	],
	"./it-flickr.svg": [
		25889,
		25889
	],
	"./it-folder.svg": [
		89485,
		89485
	],
	"./it-fullscreen.svg": [
		7016,
		7016
	],
	"./it-funnel.svg": [
		41458,
		41458
	],
	"./it-github.svg": [
		94403,
		94403
	],
	"./it-google.svg": [
		34174,
		34174
	],
	"./it-hearing.svg": [
		80293,
		80293
	],
	"./it-help-circle.svg": [
		20455,
		20455
	],
	"./it-help.svg": [
		69170,
		69170
	],
	"./it-horn.svg": [
		17594,
		17594
	],
	"./it-inbox.svg": [
		41958,
		41958
	],
	"./it-info-circle.svg": [
		42715,
		42715
	],
	"./it-instagram.svg": [
		65728,
		65728
	],
	"./it-key.svg": [
		421,
		421
	],
	"./it-less-circle.svg": [
		52410,
		52410
	],
	"./it-link.svg": [
		62784,
		62784
	],
	"./it-linkedin-square.svg": [
		81379,
		81379
	],
	"./it-linkedin.svg": [
		67174,
		67174
	],
	"./it-list.svg": [
		95120,
		95120
	],
	"./it-lock.svg": [
		60815,
		60815
	],
	"./it-locked.svg": [
		19578,
		19578
	],
	"./it-logout.svg": [
		18814,
		67740
	],
	"./it-mail-open.svg": [
		43965,
		43965
	],
	"./it-mail.svg": [
		11190,
		11190
	],
	"./it-map-marker-circle.svg": [
		87607,
		87607
	],
	"./it-map-marker-minus.svg": [
		31157,
		31157
	],
	"./it-map-marker-plus.svg": [
		92296,
		92296
	],
	"./it-map-marker.svg": [
		90005,
		90005
	],
	"./it-mastodon-square.svg": [
		59281,
		59281
	],
	"./it-mastodon.svg": [
		41845,
		41845
	],
	"./it-maximize-alt.svg": [
		31624,
		31624
	],
	"./it-maximize.svg": [
		27694,
		27694
	],
	"./it-medium-square.svg": [
		49402,
		49402
	],
	"./it-medium.svg": [
		96766,
		96766
	],
	"./it-minimize.svg": [
		81554,
		81554
	],
	"./it-minus-circle.svg": [
		7236,
		7236
	],
	"./it-minus.svg": [
		76851,
		76851
	],
	"./it-moodle-square.svg": [
		63965,
		63965
	],
	"./it-moodle.svg": [
		76192,
		76192
	],
	"./it-more-actions.svg": [
		73533,
		73533
	],
	"./it-more-items.svg": [
		33927,
		33927
	],
	"./it-note.svg": [
		56722
	],
	"./it-open-source.svg": [
		46680,
		46680
	],
	"./it-pa.svg": [
		38583,
		38583
	],
	"./it-password-invisible.svg": [
		53989,
		53989
	],
	"./it-password-visible.svg": [
		41841,
		41841
	],
	"./it-pencil.svg": [
		21063,
		21063
	],
	"./it-piattaforme.svg": [
		79321,
		79321
	],
	"./it-pin.svg": [
		88203,
		88203
	],
	"./it-pinterest-square.svg": [
		31229,
		31229
	],
	"./it-pinterest.svg": [
		69574,
		69574
	],
	"./it-plug.svg": [
		50114,
		50114
	],
	"./it-plus-circle.svg": [
		40034,
		40034
	],
	"./it-plus.svg": [
		48504,
		48504
	],
	"./it-presentation.svg": [
		43295,
		43295
	],
	"./it-print.svg": [
		71201,
		71201
	],
	"./it-quora-square.svg": [
		99853,
		22436
	],
	"./it-quora.svg": [
		59432,
		59432
	],
	"./it-reddit-square.svg": [
		76773,
		76773
	],
	"./it-reddit.svg": [
		24629,
		24629
	],
	"./it-refresh.svg": [
		45470,
		45470
	],
	"./it-restore.svg": [
		24877,
		24877
	],
	"./it-rss-square.svg": [
		14371,
		14371
	],
	"./it-rss.svg": [
		88153,
		88153
	],
	"./it-search.svg": [
		71086
	],
	"./it-settings.svg": [
		80152,
		80152
	],
	"./it-share.svg": [
		58559,
		58559
	],
	"./it-slack-square.svg": [
		72454,
		72454
	],
	"./it-slack.svg": [
		2093,
		2093
	],
	"./it-snapchat-square.svg": [
		71827,
		71827
	],
	"./it-snapchat.svg": [
		38542,
		38542
	],
	"./it-software.svg": [
		80870,
		80870
	],
	"./it-stackexchange-square.svg": [
		54389,
		54389
	],
	"./it-stackexchange.svg": [
		67926,
		67926
	],
	"./it-stackoverflow-square.svg": [
		20561,
		20561
	],
	"./it-stackoverflow.svg": [
		56882,
		56882
	],
	"./it-star-full.svg": [
		80341,
		80341
	],
	"./it-star-outline.svg": [
		77876,
		77876
	],
	"./it-team-digitale.svg": [
		87028,
		87028
	],
	"./it-telegram.svg": [
		58218,
		58218
	],
	"./it-telephone.svg": [
		8744,
		8744
	],
	"./it-tiktok-square.svg": [
		7419,
		7419
	],
	"./it-tiktok.svg": [
		74324,
		74324
	],
	"./it-tool.svg": [
		67897,
		67897
	],
	"./it-twitter-square.svg": [
		5902,
		5902
	],
	"./it-twitter.svg": [
		17193,
		17193
	],
	"./it-unlocked.svg": [
		34876,
		34876
	],
	"./it-upload.svg": [
		17342,
		17342
	],
	"./it-user.svg": [
		76289,
		76289
	],
	"./it-video.svg": [
		31345,
		31345
	],
	"./it-vimeo-square.svg": [
		29494,
		29494
	],
	"./it-vimeo.svg": [
		41956,
		41956
	],
	"./it-warning-circle.svg": [
		93694,
		93694
	],
	"./it-warning.svg": [
		40591,
		40591
	],
	"./it-whatsapp-square.svg": [
		25304,
		25304
	],
	"./it-whatsapp.svg": [
		86092,
		86092
	],
	"./it-wifi.svg": [
		7335,
		7335
	],
	"./it-youtube.svg": [
		10303,
		10303
	],
	"./it-zoom-in.svg": [
		60021,
		60021
	],
	"./it-zoom-out.svg": [
		74896,
		74896
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 19164;
module.exports = webpackAsyncContext;